import { TimeGap, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';

/**
 * Période de découpage des chronocodes
 * @author SVA
 */
export class TimeGapVO {
  /**
   * Le VO source provenant du back
   */
  private _source: TimeGap;

  public get source(): TimeGap {
    return this.getSource();
  }
  public set source(pSource: TimeGap) {
    this.setSource(pSource);
  }
  protected getSource(): TimeGap {
    return this._source || new TimeGap();
  }
  protected setSource(pSource: TimeGap) {
    this._source = pSource;
  }

  constructor(pSource?: TimeGap) {
    this._source = pSource ? pSource : new TimeGap();
  }

  /** Code */
  public get code(): string {
    return this.getCode();
  }
  public set code(pCode: string) {
    this.setCode(pCode);
  }
  protected getCode(): string {
    return this._source.code;
  }
  protected setCode(pCode: string) {
    this._source.code = pCode;
  }

  /** unité temporelle */
  public get unit(): string {
    return this.getUnit();
  }
  public set unit(pUnit: string) {
    this.setUnit(pUnit);
  }
  protected getUnit(): string {
    return this._source.unit;
  }
  protected setUnit(pUnit: string) {
    this._source.unit = pUnit;
  }

  /** pondération temporelle */
  public get value(): number {
    return this.getValue();
  }
  public set value(pValue: number) {
    this.setValue(pValue);
  }
  protected getValue(): number {
    return this._source.value;
  }
  protected setValue(pValue: number) {
    this._source.value = pValue;
  }

  /** poids temporel */
  public get temporalWeight(): number {
    return this.getTemporalWeight();
  }
  public set temporalWeight(pWeight: number) {
    // this.setValue(pWeight);
    this.setTemporalWeight(pWeight);
  }
  protected getTemporalWeight(): number {
    return this._source.temporalWeight;
  }
  protected setTemporalWeight(pWeight: number) {
    this._source.temporalWeight = pWeight;
  }
  /** Poids utilisé pour les tris */
  protected get temporalWeightSort(): number {
    return this._source.temporalWeight;
  }
  protected getTemporalWeightSort(): number {
    // Undefined au plus bas pour les sort
    return this.temporalWeight ? this.temporalWeight : 0;
  }
  /** période calendaire */
  public get calendar(): boolean {
    return this.getCalendar();
  }
  public set calendar(pCalendar: boolean) {
    this.setCalendar(pCalendar);
  }
  protected getCalendar(): boolean {
    return this._source.calendar;
  }
  protected setCalendar(pCalendar: boolean) {
    this._source.calendar = pCalendar;
  }

  public set label(value: TranslatedEmb) {
    this._source.label = value;
  }
  public get label(): TranslatedEmb {
    return this._source.label;
  }


  /**
   * Libellé traduit
   * @return string
   */
  public get trsLabel(): string {
    return Model.getInstance().localeEngine.translate(this.label);
  }

  /** Le gap est-il persisté? */
  public exist(): boolean {
    // l'objet existe en BDD (id)
    return this._source.id > 0;
  }
}
